'use client'

import { useEffect } from 'react'

let _usingKeyboard = false
let _initialized = false

/**
 * Tracks whether the user is currently navigating via keyboard (Tab) vs mouse.
 * Returns a getter so callers always read the current value (the value can flip
 * mid-event chain). Mirrors the global flag used in the legacy components.html.
 */
export function isUsingKeyboard(): boolean {
  return _usingKeyboard
}

export function useKeyboardModeTracker() {
  useEffect(() => {
    if (_initialized) return
    _initialized = true
    const onMouseDown = () => {
      _usingKeyboard = false
    }
    const onKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Tab') _usingKeyboard = true
    }
    document.addEventListener('mousedown', onMouseDown)
    document.addEventListener('keydown', onKeyDown)
    // No cleanup — we want this tracker alive for the lifetime of the app.
  }, [])
}
